import { Injectable } from '@angular/core';

import { ActivatedRoute } from '@angular/router';

import { ContextFactory } from '@shared/factories/context/context.factory';
import { ConceptStateFactory } from '@shared/factories/concept-state/concept-state.factory';
import { ApiPropertiesFactory } from '@shared/factories/api-properties/api-properties.factory';
import { LoaderFactory } from '@shared/factories/loader/loader.factory';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { ModalServiceService } from '@shared/services/modal-service/modal-service.service';
import { SnapShotsService } from '@shared/services/snap-shots/snap-shots.service';
import { ApiServiceService } from '../api-service/api-service.service';
import { AfTranslateFactory } from '@shared/modules/translate/factory/translate.factory';


@Injectable({
  providedIn: 'root'
})
export class ConceptUtilsService {
  fieldContainerId: any = this.route.snapshot.params['fieldContainerId'];

  constructor(private route: ActivatedRoute,
    public context: ContextFactory,
    private conceptState: ConceptStateFactory,
    private apiProperties: ApiPropertiesFactory,
    private loader: LoaderFactory,
    private commonUtilsService: CommonUtilsService,
    private modalService: ModalServiceService,
    private snapshotsService: SnapShotsService,
    private apiService: ApiServiceService,
    private translate: AfTranslateFactory) { }

  exitConcept(configuration:any): any {
    let userPublic:boolean = configuration.userPublic?configuration.userPublic:false;
    return new Promise((resolve:any, reject:any)=>{
      if(!((this.conceptState.getAmount() || this.conceptState.getProcess()))){
        resolve();
      }else{
        this.modalService.warningModal({text: configuration.textModal, typeButtons: configuration.typeButtons})
          .subscribe((result:any) => {
            switch (result.result) {
              case 'cancel':
                reject();
                break;
              case 'save':
              case 'save-navegate':
              case 'save-and-continue':
              case 'save-and-share':
              case 'save-exit-tab':
              case 'save-exit':
              case 'continue':
                let errors = this.commonUtilsService.checkRequiredFields(configuration.concept, userPublic);
                let that = this;
                if(errors.validateErrors){
                  this.modalService.errorModal({ text: this.translate.instant('concept-form.no-validate-fields') });
                }else if (errors.commonErrors && errors.blockedErrors) {
                  this.modalService.errorModal({ text: this.translate.instant('concept-form.has-blocked-fields') });
                }else if(errors.commonErrors){
                  this.modalService.warningModal({ text: this.translate.instant('concept-form.error-validate-fields'), typeButtons: 'saveMandatoryForm' })
                    .subscribe((result:any)=>{
                      if(result.result==='ok'){
                        this.acceptChanges(configuration).then(function(){
                          that.modalService.successModal({ text: that.translate.instant('concept-form.save-ok') })
                            .subscribe((result:any) => {
                              if(configuration.loader){
                                that.loader.openLoader(configuration.loader);
                              }
                              resolve(result.result);
                            })
                        })
                      }
                    });
                } else {
                  this.acceptChanges(configuration).then(function(){
                    that.modalService.successModal({ text: that.translate.instant('concept-form.save-ok') })
                      .subscribe((result:any) => {
                        if(configuration.loader){
                          that.loader.openLoader(configuration.loader);
                        }
                        resolve(result.result);
                      })
                  })
                }
                break;
              case 'discard-navegate':
              case 'without-save':
              case 'discard-and-share':
              case 'discard-exit':
                this.conceptState.removeAll();
                resolve(result.result);
                break;
            }
          })
      }
    })
  }

  configureLoader(selected: any){
    switch(selected){
      case 'general':
        return 'landing-page-on-init';
      case 'task':
        return 'charge-' + selected + '-concept-list';
      case 'historic':
      case 'alerts':
        return 'charge-' + selected + '-concept-list';
      default:
        return 'documentation-list-on-init';
    }
  }

  acceptChanges(configuration:any) {
    return new Promise((resolveAcceptChanges:any)=>{
      this.loader.openLoader('concept-utils-loader');
      this.saveConceptFields(configuration.concept)
        .then(()=>{
          this.saveSnapshot(configuration.concept);
          this.loader.closeLoader(['concept-utils-loader']);
          resolveAcceptChanges();
      });
    });
  }

  saveConceptFields(concept:any){
    let url = 'conceptdata';
    let id = concept.conceptObjectId;
    if(this.fieldContainerId){
      url = 'conceptdata/'+concept.conceptObjectId;
      id = this.fieldContainerId;
    }
    return this.apiService.patch(url, id, concept.evaluatedFields)
      .then((data:any)=> {
        this.conceptState.removeAll();
        this.loader.closeLoader(['save-exit-concept']);
        return data;
      }, (errorData:any)=>{})
  }

  saveSnapshot(concept:any) {
    if (this.fieldContainerId) {
      let historicJson = this.snapshotsService.getConceptJson(concept);
      this.snapshotsService.saveForConcept(concept.conceptObjectId, historicJson) //, historicHtml
    }
  }

  addProtectionData(selectedLanguages:any){
    let protectionData = this.getProtectionDataLanguage(selectedLanguages, sessionStorage.getItem('selectLanguage'));
    if(!protectionData){
      protectionData = this.getProtectionDataLanguage(selectedLanguages, this.apiProperties.defaultLanguage);
    }
    return protectionData;
  }

  getProtectionDataLanguage(selectedLanguages:any, appLanguage:any){
    for(let i = 0; i < selectedLanguages.length; i++){
      let language = selectedLanguages[i];
      if(language.language === appLanguage){
        return language;
      }
    }
  }

  checkModalLocked(configuration: any){
    return new Promise((resolve:any, reject:any)=>{
      if(configuration.saveConcept && configuration.concept.conceptNamedKey === 'Cliente' && configuration.concept.productId === 'blanqueo' && configuration.concept.addToScoring.valueRisk === 4 && configuration.concept.clientStateId === 1){
        configuration.concept.clientStateId = 2;
        this.loader.closeLoader([configuration.loader]);
        this.modalService.alertModal({text: configuration.literalQuestion })
          .subscribe((result:any)=>{
            if(result.result==='ok'){
              this.loader.openLoader(configuration.loader);
              resolve();
            }
          });
      }else{
        resolve();
      }
    })
  }

  selectOptionsLink(configuration: any){
    switch(configuration.action){
      case 'copyLink':
        this.copyText(configuration);
        break;
      case 'shareLink':
        this.shareLink(configuration);
        break;
      case 'generateQR':
        this.generateQr(configuration.text);
        break;
    }
  }

  copyText(configuration:any) {
    try{
      this.commonUtilsService.clipboardText(configuration.text);
      this.commonUtilsService.clickShowToolip(configuration.buttonCopyTooltip, configuration.typeButtonTooltip, configuration.time);
    }catch(error:any){
      console.error('Error al copiar la URL de enlace público:', error);
    }
  }

  generateQr(url:any){
    this.modalService.qrModal(url)
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          this.modalService.successModal({ text: this.translate.instant('channel-configuration.qr-succes') });
        }
    })
  }

  shareLink(configuration:any){
    let configurationShare : any = {
      conceptId: configuration.conceptId
    }
    this.modalService.shareLinkModal(configurationShare)
      .subscribe((result:any)=>{
        if(result.result==='ok'){
          this.sharePublicConcept(result, configuration);
        }
      })
  }

  sharePublicConcept(result: any, configuration:any){
    let copyNotification = result.checkCopyNotification ? 1 : 0;
    this.loader.openLoader('share-public-concept');
    this.apiService.patch('concepts/' + configuration.evaluationId, configuration.conceptId + '/sharepublic/' + copyNotification , result.selectContacts)
      .then((data:any) => {
        this.modalService.successModal({ text: this.translate.instant('folder.notification-sent-ok') });
        this.loader.closeLoader('share-public-concept');
      }, (errorData:any)=>{
        this.modalService.errorModal({ text: this.translate.instant('folder.error-shared-link') });
        this.loader.closeError();
      })
  }

  convertToFormDataFavicon(favicon:any){
    let fd = new FormData();
    let newFavicon = this.commonUtilsService.baseToFormdata(favicon);
    fd.append('file', newFavicon);
    return fd;
  }
}
